import * as trace from 'owa-trace';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import FolderNodeViewState from '../store/schema/FolderNodeViewState';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import initializeFolderViewStates from '../actions/data-loading/initializeFolderViewStates';
import setFolderNodeViewState from '../actions/setFolderNodeViewState';
import { FolderViewState } from '../utils/getNewOrModifiedFolderViewState';
import { orchestrator } from 'satcheljs';

/**
 * Orchestrator which sets the initial folderNodeViewStates in the store.
 */
export default orchestrator(initializeFolderViewStates, () => {
    const folderViewStatesFromUserConfig =
        getUserConfiguration().ViewStateConfiguration.FolderViewState || [];
    const rootFolderId = folderNameToId('msgfolderroot');

    try {
        folderViewStatesFromUserConfig.forEach(folderViewState => {
            const parsedFolderViewState: FolderViewState = JSON.parse(folderViewState);
            if (parsedFolderViewState) {
                const folderId =
                    parsedFolderViewState.FolderId && parsedFolderViewState.FolderId.Id;
                let mailFolderViewState: FolderNodeViewState;

                // If the folder is the root folder, use UserOptions.IsMailRootFolderTreeCollapsed.
                if (folderId === rootFolderId) {
                    mailFolderViewState = {
                        isExpanded: !getUserConfiguration().UserOptions
                            .IsMailRootFolderTreeCollapsed,
                    };
                } else {
                    mailFolderViewState = {
                        isExpanded: !!parsedFolderViewState.IsExpanded,
                    };
                }
                setFolderNodeViewState(folderId, mailFolderViewState);
            }
        });
    } catch (e) {
        trace.errorThatWillCauseAlert(
            'Error encountered while initializing folderViewState' + e.message
        );
    }
});
